import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {client} from "../_api/client";
import {IDLE, LOADING, SUCCESS, FAILED} from "../common/statuses";

const REQUESTS = "requests";

const initialState = {
    getRequests: {
        data: undefined,
        status: IDLE,
    },
    close: {
        status: IDLE
    }
}

export const getAllCourseRequests = createAsyncThunk(
    `${REQUESTS}/getAllCourse`,
    async () => {
        const response = await client.get("/request/getAll/course")
        return response.data
    }
)

export const getAllCollaborationRequests = createAsyncThunk(
    `${REQUESTS}/getAllCollaboration`,
    async () => {
        const response = await client.get("/request/getAll/collaboration")
        return response.data
    }
)

export const close = createAsyncThunk(
    `${REQUESTS}/close`,
    async (id) => {
        const response = await client.get(`/request/close/${id}`)
        return response.data
    }
)

const requestService = createSlice({
    name: REQUESTS,
    initialState,
    reducers: {
        closeRequest: () => {
            return {...initialState}
        }
    },
    extraReducers(builder) {
        builder
            .addCase(getAllCourseRequests.pending, (state) => {
                state.getRequests.status = LOADING
            })
            .addCase(getAllCourseRequests.fulfilled, (state, action) => {
                state.getRequests.status = SUCCESS
                state.getRequests.data = action.payload
            })
            .addCase(getAllCourseRequests.rejected, (state) => {
                state.getRequests.status = FAILED
            })
            .addCase(getAllCollaborationRequests.pending, (state) => {
                state.getRequests.status = LOADING
            })
            .addCase(getAllCollaborationRequests.fulfilled, (state, action) => {
                state.getRequests.status = SUCCESS
                state.getRequests.data = action.payload
            })
            .addCase(getAllCollaborationRequests.rejected, (state) => {
                state.getRequests.status = FAILED
            })

            .addCase(close.pending, (state) => {
                state.close.status = LOADING
            })
            .addCase(close.fulfilled, (state, action) => {
                state.close.status = SUCCESS
                state.getRequests.data = action.payload
            })
            .addCase(close.rejected, (state) => {
                state.close.status = FAILED
            })
    }
})

export const {closeRequest} = requestService.actions
export default requestService.reducer